// 导入键盘组件
import dyKeyboard from "../packages/dyKeyboard/dyKeyboard.vue";
import VDyKeyboard from '../packages/dyKeyboard/VDyKeyboard.js';


// 存储组件列表
const components = {
    dyKeyboard
};
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue, options) {
    // 判断是否安装
    if (install.installed) return;

    // 遍历注册全局组件
    for (let key in components) {
        Vue.component(components[key].name, components[key]);
    }

    // 注册自定义指令
    VDyKeyboard(Vue, options);
};

// 判断是否是直接引入文件
if (typeof window !== "undefined" && window.Vue) {
    install(window.Vue);
}
export default {
    // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
    install,
    // 以下是具体的组件列表
    ...components
};
